import { FC, PropsWithChildren } from "react";

export const EmptyBody: FC<PropsWithChildren> = ({ children }) => (
  <div data-component="EmptyBody" className="flex flex-col gap-2">
    { children }
  </div>
);
